module.exports = __webpack_public_path__ + "img/icon-search.572211b2.png";